import React from 'react';
import './Unsuccessful.css';

interface CancelledOrderMessageProps {
  className?: string;
}

const CancelledOrderMessage: React.FC<CancelledOrderMessageProps> = ({ className }) => {
  return (
    <div className={`cancelled-order-message ${className ? className : ''}`}>
      Order has been cancelled.
    </div>
  );
};

export default CancelledOrderMessage;